import React, { useState, useEffect } from 'react';
import { SuperAdminLayout } from '../../components/SuperAdminLayout';
import api from '../../lib/api';
import { Building2, Users, Activity } from 'lucide-react';

const DashboardPage = () => {
  const [stats, setStats] = useState({
    total_companies: 0,
    active_companies: 0,
    total_users: 0,
    recent_companies: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/superadmin/dashboard');
        setStats(response.data);
      } catch (error) {
        console.error('Failed to fetch dashboard stats', error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  const StatCard = ({ icon: Icon, label, value, color }) => (
    <div className="panel border border-border">
      <div className="flex items-center gap-4">
        <div className={`w-12 h-12 rounded-md ${color} flex items-center justify-center`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
        <div>
          <p className="text-2xl font-semibold text-foreground">{loading ? '...' : value}</p>
          <p className="text-sm text-muted-foreground">{label}</p>
        </div>
      </div>
    </div>
  );

  return (
    <SuperAdminLayout>
      <div className="p-8" data-testid="dashboard-page">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-2xl font-semibold text-foreground">Dashboard</h1>
          <p className="text-muted-foreground mt-1">Welcome to WingsDiet SuperAdmin</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <StatCard
            icon={Building2}
            label="Total Companies"
            value={stats.total_companies}
            color="bg-primary"
          />
          <StatCard
            icon={Activity}
            label="Active Companies"
            value={stats.active_companies}
            color="bg-green-600"
          />
          <StatCard
            icon={Users}
            label="Total Users"
            value={stats.total_users}
            color="bg-amber-500"
          />
        </div>

        {/* Recent Companies */}
        <div className="panel border border-border p-0">
          <div className="px-6 py-4 border-b border-border">
            <h2 className="font-semibold text-foreground">Recent Companies</h2>
          </div>
          <div className="p-6">
            {stats.recent_companies.length === 0 ? (
              <p className="text-muted-foreground text-sm text-center py-8">No companies yet</p>
            ) : (
              <div className="space-y-4">
                {stats.recent_companies.map((company) => (
                  <div key={company.id} className="flex items-center justify-between py-2">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-md bg-muted flex items-center justify-center">
                        <Building2 className="w-5 h-5 text-muted-foreground" />
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground">{company.name}</p>
                        <p className="text-xs text-muted-foreground">{company.email}</p>
                      </div>
                    </div>
                    <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                      company.status === 'active' 
                        ? 'bg-green-100 text-green-700' 
                        : 'bg-muted text-gray-600'
                    }`}>
                      {company.status}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </SuperAdminLayout>
  );
};

export default DashboardPage;
